<div class="merge-vehicle">
  <div class="dialog-header">
    <div class="columns">
      <div class="icon">
        <div class="icon-circle"><i class="fal fa-user pt-1"></i></div>
      </div>
      <div class="text">
        <div class="font-bold black mb-2 tml-heading">
          Merge customers
          <span class=""></span>
        </div>
        <div class="gray-55 tml-sub-header">All details from the primary customer will be saved</div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeDuplicateVehicleModal({})"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <div class="dialog-body-inner">
      <nav class="merge-customer-tabs">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link" id="select-customer-tab"
            [ngClass]="[selectedTab === 'select-customer-tab' ? 'active' : '', isValidCompleted ? 'active' : '']">
            <div class="tab-count-bubble" [ngClass]="[isValidCompleted ? 'active' : '']">
              <span *ngIf="!isValidCompleted">1</span>
              <span *ngIf="isValidCompleted"><i class="fal fa-check"></i></span>
            </div>
            Select customers
            <div class="border-left" [ngClass]="[isValidCompleted ? 'border-primary' : '']"></div>
          </a>

          <a class="nav-item nav-link" id="qbo-tab"
            [ngClass]="[selectedTab === 'qbo-tab' ? 'active' : '', isValidQBOCompleted ? 'active' : '']"
            *ngIf="isQBOEnabled">
            <div class="tab-count-bubble" [ngClass]="[isValidQBOCompleted ? 'active' : '']">
              <span *ngIf="!isValidQBOCompleted">2</span>
              <span *ngIf="isValidQBOCompleted"><i class="fal fa-check"></i></span>
            </div>
            QBO
            <div class="border-left" [ngClass]="[isValidQBOCompleted ? 'border-primary' : '']"></div>
          </a>

          <a class="nav-item nav-link" id="confirmation-tab"
            [ngClass]="[selectedTab === 'confirmation-tab' ? 'active' : '']">
            <div class="tab-count-bubble">
              {{ isQBOEnabled ? '3' : '2' }}
            </div>
            Confirmation
          </a>
        </div>
      </nav>
      <div class="tab-content merge-customer-tabs-content" id="nav-tabContent">
        <div class="tab-pane fade" [ngClass]="[selectedTab === 'select-customer-tab' ? 'active show' : '']"
          id="select-customer" role="tabpanel" aria-labelledby="select-customer-tab">
          <div class="row merge-customer-row">
            <div class="pl-0 col left-box merge-customer-col">
              <p class="font-12 gray-35 font-bold mb-2">Select customer</p>

              <div class="merge-search-box">
                <app-auto-complete theme="border" id="ac-appt-customer" listId="ac-appt-customer-list"
                  placeholder="Search customer" scrollHeight="192px" noRecordIcon="fal fa-user font-16 pr-2"
                  noRecordText="No customers match your search" leftIcon="fal fa-user font-gray font-20"
                  [isLoading]="isLoading" [hasSearchIcon]="true" [showDisabledIcon]="false" [closeOnSelection]="true"
                  [hasEditableField]="false" [hasCustomEditableField]="false" name="est-vehicle"
                  inactiveItemsKey="isActive" [value]="customerSearchKey" [suggestions]="customerSearchResults"
                  [disabled]="false" [fontSize]="14" [isDropdownIconVisible]="true"
                  [isClearIconVisible]="isClearIconVisible" styleClassInput="text-ellipse bg-gray-75 width-240"
                  [textTruncate]="true" (appSelect)="onSearchSelect($event)"
                  (appCompletedMethod)="customerSearch($event)" (appClear)="onSearchClear($event, false)">
                  <ng-template let-item appTemplate="item">
                    <div class="" (click)="!item?.isActive ? $event.stopPropagation() : null"
                      [ngClass]="{ disabled: !item?.isActive }">
                      <div class="font-12">
                        <b>{{ item.fullNameQBO }}</b>&nbsp;{{ item.phone | mask: '(000) 000-0000' }}
                        <br />
                        {{ item.email }}
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
              <div class="merge-search-result-wrapper">
                <i class="fal fa-spinner rotate loader" *ngIf="primaryLoader"></i>
                <div class="vehicle-info-wrapper" *ngIf="selectedPrimary && selectedPrimary.fullNameQBO">
                  <div class="font-secondary-700 vehicle-info">
                    <div class="text-truncate">
                      <span class="font-600 font-14 font-capitalize">{{ primaryCustomerObj.Name }} (Display name)
                      </span>
                    </div>
                  </div>
                  <div class="font-gray-45 font-14 vehicle-info" *ngFor="let item of primaryCustomerObj | keys">
                    <div class="text-truncate">
                      <span class="font-600"> {{ item }}:</span> {{ primaryCustomerObj[item] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col center-box merge-customer-col">
              <p class="font-12 gray-35 font-bold m-0 mb-2">Merge selected customer</p>

              <div class="merge-search">
                <app-auto-complete theme="border" id="ac-appt-customer" listId="ac-appt-customer-list"
                  placeholder="Search customer" scrollHeight="192px" noRecordIcon="fal fa-user font-16 pr-2"
                  noRecordText="No customers match your search" leftIcon="fal fa-user font-gray font-20"
                  [isLoading]="isLoading" [hasSearchIcon]="true" [showDisabledIcon]="false" [closeOnSelection]="true"
                  [hasEditableField]="false" [hasCustomEditableField]="false" name="est-vehicle"
                  inactiveItemsKey="isActive" [value]="secondaryCustomerKey" [suggestions]="secondaryCustomer"
                  [disabled]="false" [fontSize]="14" [isDropdownIconVisible]="true"
                  [isClearIconVisible]="isClearSecondaryIconVisible" styleClassInput="text-ellipse bg-gray-75 width-240"
                  [textTruncate]="true" (appSelect)="onSearchSelect($event, true)"
                  (appCompletedMethod)="customerSearch($event, true)" (appClear)="onSearchClear($event, true)">
                  <ng-template let-item appTemplate="item">
                    <div class="" (click)="!item?.isActive ? $event.stopPropagation() : null"
                      [ngClass]="{ disabled: !item?.isActive }">
                      <div class="font-12">
                        <b>{{ item.fullNameQBO }}</b>&nbsp;{{ item.phone | mask: '(000) 000-0000' }}
                        <br />
                        {{ item.email }}
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
              <div class="merge-search-result-wrapper">
                <i class="fal fa-spinner rotate loader" *ngIf="secondaryLoader"></i>
                <div class="vehicle-info-wrapper" *ngIf="selectedSecondary && selectedSecondary.fullNameQBO">
                  <div class="font-secondary-700 vehicle-info">
                    <div class="text-truncate">
                      <span class="font-600 font-14 font-capitalize">{{ secondaryCustomerObj.Name }} (Display name)
                      </span>
                    </div>
                  </div>
                  <div class="font-gray-45 font-14 vehicle-info" *ngFor="let item of secondaryCustomerObj | keys">
                    <div class="text-truncate">
                      <span class="font-600"> {{ item }}:</span> {{ secondaryCustomerObj[item] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col pr-0 right-box merge-customer-col">
              <p class="font-12 gray-35 font-bold mb-2">Merged customer</p>
              <div class="no-merged-customer" *ngIf="!isMergeCustomerSelected">
                <i class="fas fa-user"></i>
                <div>
                  Merged customer details will be shown here
                </div>
              </div>
              <div class="merged-customer" *ngIf="isMergeCustomerSelected">
                <div class="vehicle-info text-truncate">
                  <i class="fal fa-user font-gray font-20"></i>
                  <span class="ml-2">
                    {{ !selectedPrimary.fullNameQBO ? 'No merged Customer' : selectedPrimary.fullNameQBO }}
                  </span>
                </div>
              </div>

              <div class="merge-search-result-wrapper">
                <div class="vehicle-info-wrapper" *ngIf="isMergeCustomerSelected">
                  <div class="font-secondary-700 vehicle-info">
                    <div class="text-truncate">
                      <span class="font-600 font-14 font-capitalize">{{ mergedCustomerObj.Name }} (Display name) </span>
                    </div>
                  </div>
                  <div class="font-gray-45 font-14 vehicle-info" *ngFor="let item of mergedCustomerObj | keys">
                    <div class="text-truncate">
                      <span class="font-600"> {{ item }}:</span> {{ mergedCustomerObj[item] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" [ngClass]="[selectedTab === 'qbo-tab' ? 'active show' : '']" id="qbo" role="tabpanel"
          aria-labelledby="qbo-tab">
          <div *ngIf="!isQboCustomerExist" class="no-qbo-customer">
            <div class="no-qbo-vertical">
              <div>
                <img src="assets/img/qbo-customer.jpg" />
              </div>
              <div>
                No corresponding customers found in QBO, please proceed to the next step
              </div>
            </div>
          </div>
          <div class="p-4" *ngIf="isQboCustomerExist">
            <div class="qbo-heading-wrapper mb-4">
              <h5>Customers '{{ selectedPrimary.fullNameQBO }}' and '{{ selectedSecondary.fullNameQBO }}' found in QBO
              </h5>
              <p>The selected customers are also present in your QBO account. Please merge these customer in QBO by
                following the steps below:</p>
            </div>

            <div class="row mb-4 stepper-info">
              <div class="col">
                <h6>Step 1:</h6>
                <p>
                  Switch to QuickBooks and enter Single User Mode. You may need to pause the QuickBooks connector to do
                  this. Full instructions on how to do this can be found
                  <a href="javascript::" class="font-primary">here</a>.
                </p>
              </div>
              <div class="col">
                <h6>Step 2:</h6>
                <p>while in QuickBooks, merge customer A into customer B. Click <a href="javascript::"
                    class="font-primary">here</a> if you need instructions on how to do this.</p>
              </div>
              <div class="col"></div>
            </div>

            <div class="row stepper-info">
              <div class="col">
                <h6>Step 3:</h6>
                <p>After merging in QuickBooks, switch back to Multi-User Mode. Full directions on how to do this can be
                  found <a href="javascript::" class="font-primary">here</a>.</p>
              </div>
              <div class="col">
                <h6>Step 4:</h6>
                <p>
                  Once the steps have been completed click the button below to merge the customers in AutoLeap.
                </p>
              </div>
              <div class="col"></div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" [ngClass]="[selectedTab === 'confirmation-tab' ? 'active show' : '']"
          id="confirmation" role="tabpanel" aria-labelledby="confirmation-tab">
          <div class="confirm-row">
            <div class="merging">Are you sure you want to merge these customers and delete `{{
              selectedSecondary.fullNameQBO }}` ?</div>
            <div class="merging-step">
              This is an irreversible action, please review the details below before merging the customers
            </div>
          </div>
          <div class="row merge-customer-row h-auto">
            <div class="pl-0 col left-box merge-customer-col">
              <p class="font-12 gray-35 font-bold mb-2">Select customer</p>
              <div class="merge-search-result-wrapper" [ngClass]="[selectedTab === confirmationTab ? 'mt-0' : '']">
                <div class="vehicle-info-wrapper" *ngIf="selectedPrimary && selectedPrimary.fullNameQBO">
                  <div class="font-secondary-700 vehicle-info">
                    <div class="text-truncate">
                      <span class="font-600 font-14 font-capitalize">{{ primaryCustomerObj.Name }} (Display name)
                      </span>
                    </div>
                  </div>
                  <div class="font-gray-45 font-14 vehicle-info" *ngFor="let item of primaryCustomerObj | keys">
                    <div class="text-truncate">
                      <span class="font-600"> {{ item }}:</span> {{ primaryCustomerObj[item] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col center-box merge-customer-col">
              <p class="font-12 gray-35 font-bold mb-2">Merge selected customer</p>
              <div class="merge-search-result-wrapper">
                <div class="vehicle-info-wrapper" *ngIf="selectedSecondary && selectedSecondary.fullNameQBO">
                  <div class="font-secondary-700 vehicle-info">
                    <div class="text-truncate">
                      <span class="font-600 font-14 font-capitalize">{{ secondaryCustomerObj.Name }} (Display name)
                      </span>
                    </div>
                  </div>
                  <div class="font-gray-45 font-14 vehicle-info" *ngFor="let item of secondaryCustomerObj | keys">
                    <div class="text-truncate">
                      <span class="font-600"> {{ item }}:</span> {{ secondaryCustomerObj[item] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col right-box pr-0 merge-customer-col">
              <p class="font-12 gray-35 font-bold mb-2">Merged customer</p>
              <div class="merge-search-result-wrapper">
                <div class="vehicle-info-wrapper" *ngIf="isMergeCustomerSelected">
                  <div class="font-secondary-700 vehicle-info">
                    <div class="text-truncate">
                      <span class="font-600 font-14 font-capitalize">{{ mergedCustomerObj.Name }} (Display name) </span>
                    </div>
                  </div>
                  <div class="font-gray-45 font-14 vehicle-info" *ngFor="let item of mergedCustomerObj | keys">
                    <div class="text-truncate">
                      <span class="font-600"> {{ item }}:</span> {{ mergedCustomerObj[item] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer flex-between-center">
    <div class="note">
      <div class="pl-1 flex-center-center">
        <i class="fal fa-info-circle text-dark"></i>
        <span class="pl-3">
          The secondary customer will be permanently deleted, this action is not reversible
        </span>
      </div>
    </div>
    <div class="p-zero text-right float-right merge-vehicle-footer mt-1 mb-1">
      <button id="merge-vehicle-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
        (click)="closeDuplicateVehicleModal({})" *ngIf="selectedTab !== qboTab">Cancel</button>

      <button id="merge-vehicle-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
        *ngIf="selectedTab === qboTab" (click)="onBack()">Back</button>

      <button id="merge-vehicle-btn-save" class="btn btn-primary btn-submit font-bold" (click)="handleSubmit()"
        [disabled]="!isValidMerge()">
        <span class="" [ngClass]="{ 'pr-2': isProcessing }">{{
          selectedTab === confirmationTab ? 'Merge Customer' : isQboCustomerExist && isQBOEnabled && selectedTab ===
          qboTab ? 'Verify' : 'Next'
          }}</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-1"></i>
      </button>
    </div>
  </div>
</div>